/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useCallback, useState } from 'react';

import { Grid } from '@coursera/cds-core';

import type { PAGE_RENDER_OPTIONS_TYPE } from 'bundles/cml/shared/components/asset/pdfViewer/PdfPageSelectForm';
import {
  PAGE_RENDER_OPTIONS,
  PdfPageSelectForm,
} from 'bundles/cml/shared/components/asset/pdfViewer/PdfPageSelectForm';
import PdfViewer from 'bundles/cml/shared/components/asset/pdfViewer/PdfViewer';
import type { PdfDocument } from 'bundles/cml/shared/components/asset/pdfViewer/types';

import _t from 'i18n!nls/cml';

const styles = {
  viewerContainer: css`
    padding: var(--cds-spacing-800);
  `,
  formContainer: css`
    padding: var(--cds-spacing-800);
  `,
};

type Props = {
  embedStartPage?: number;
  embedEndPage?: number;
  onClose: () => void;
  onPageSelect: (pageStart?: number, pageEnd?: number) => void;
  url: string;
  assetId: string;
};

export const PdfPageSelectUI = ({ embedStartPage, embedEndPage, onClose, onPageSelect, url, assetId }: Props) => {
  const [previewPageStart, setPreviewPageStart] = useState<number | undefined>(embedStartPage);
  const [previewPageEnd, setPreviewPageEnd] = useState<number | undefined>(embedEndPage);
  const [pdfDoc, setPdfDoc] = useState<PdfDocument | undefined>(undefined);

  const onPreviewPageStartChange = (pageNum?: number) => {
    setPreviewPageStart(pageNum);
  };

  const onPreviewPageEndChange = (pageNum?: number) => {
    setPreviewPageEnd(pageNum);
  };

  const onPdfLoad = useCallback<(...args: $TSFixMe[]) => $TSFixMe>((doc: PdfDocument) => {
    setPdfDoc(doc);
  }, []);

  const onSubmit = (renderType: PAGE_RENDER_OPTIONS_TYPE) => {
    if (renderType === PAGE_RENDER_OPTIONS.CUSTOM_RANGE) {
      onPageSelect(previewPageStart, previewPageEnd);
    } else {
      onPageSelect();
    }
  };

  return (
    <Grid container>
      <Grid item xs={8} container>
        <Grid item xs>
          <div css={styles.viewerContainer}>
            <PdfViewer
              assetId={assetId}
              url={url}
              pageStart={previewPageStart}
              pageEnd={previewPageEnd}
              onPdfLoad={onPdfLoad}
            />
          </div>
        </Grid>
      </Grid>
      {pdfDoc && (
        <div css={styles.formContainer}>
          <PdfPageSelectForm
            embedStartPage={embedStartPage}
            embedEndPage={embedEndPage}
            totalPages={pdfDoc.numPages}
            onSubmit={onSubmit}
            onCancel={onClose}
            onPreviewPageStartChange={onPreviewPageStartChange}
            onPreviewPageEndChange={onPreviewPageEndChange}
            formTitleLabel={_t('Select which pages you want to display')}
            submitButtonLabel={_t('Confirm')}
          />
        </div>
      )}
    </Grid>
  );
};
